<template functional>
    <section class="hero is-fullheight is-primary">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Ошибка...
                </h1>
                <h2 class="subtitle">
                    Возможно, Вам поможет наша <a href="//kremlinpalace.org" class="has-text-weight-bold">афиша</a>.
                    <br>
                    Или свяжитесь с нами: <a href="tel:+74956207846">+7(495) 620-78-46</a> | <a
                        href="mailto:BILET@GKDKREML.RU">BILET@GKDKREML.RU</a>
                </h2>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Error",
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables";

    a {
        position: relative;

        &:before {
            position: absolute;
            content: "";
            left: 0;
            bottom: 0;
            width: 0;
            height: 1px;
            background-color: #ffffff;
            transition: $transition;
        }
        &:hover {
            &:before {
                width: 100%;
            }
        }
    }
</style>
